<template>
  <v-row no-gutters class="d-block mt-3">
    <v-col cols="12">
      <v-card>
        <v-card-text>
          <!-- Radio group -->
          <v-radio-group v-model="selectedOption" row @change="resetForm">
            <v-radio label="Por Importación" value="importacion"></v-radio>
            <v-radio label="Por Rango de Registros" value="rango"></v-radio>
            <v-radio label="Por Curso" value="curso"></v-radio>
            <v-radio label="Por Estudiante" value="estudiante"></v-radio>
          </v-radio-group>

          <!-- Por Importación -->
          <v-row v-if="selectedOption === 'importacion'" class="mt-2">
            <v-col cols="6">
              <v-select
                v-model="formData.importacionSeleccion"
                :items="importaciones"
                item-text="descripcion"
                item-value="id"
                label="Seleccionar Importación"
                outlined dense
              />
            </v-col>
          </v-row>
          
          <!-- Por Rango -->
          <v-row v-if="selectedOption === 'rango'" class="mt-2">
            <v-col cols="3">
              <v-text-field
                v-model="formData.rangoDesde"
                label="Desde"
                outlined
                dense
              />
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="formData.rangoHasta"
                label="Hasta"
                outlined
                dense
              />
            </v-col>
          </v-row>

          <!-- Por Curso -->
          <v-row v-if="selectedOption === 'curso'" class="mt-2">
            <v-col cols="3">
              <v-select
                v-model="formData.cursoAnio"
                :items="años"
                label="Año"
                outlined dense
              />
            </v-col>
            <v-col cols="3">
              <v-select
                v-model="formData.cursoPromocion"
                :items="promociones"
                label="Promoción"
                outlined dense
              />
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                v-model="formData.cursoNombre"
                :items="resultadosNombre"
                :search-input.sync="searchNombre"
                label="Nombre"
                outlined dense                
                hide-no-data
              />
            </v-col>
          </v-row>

          <!-- Tutor -->
          <v-row v-if="selectedOption === 'curso'" class="mt-2">
            <v-col cols="6">
              <v-select
                v-model="formData.cursoTutor"
                :items="tutores"
                label="Tutor"
                outlined dense
                @change="cargarSecciones"
              />
            </v-col>
            <!-- Sección -->
            <v-col cols="6">
              <v-select
                v-model="formData.cursoSeccion"
                :items="secciones"
                label="Sección"
                outlined dense
              />
            </v-col>
          </v-row>

          <!-- Por Estudiante -->
          <v-row v-if="selectedOption === 'estudiante'" class="mt-2">
            <v-col cols="6">
              <v-text-field
                v-model="formData.numeroIdentidad"
                label="Número de Identidad"
                outlined
                dense
              />
            </v-col>
          </v-row>



          <!-- Conteo -->
          <v-row class="mt-4">
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                label="Conteo de Certificados"
                v-model="conteoCertificados"
                readonly
                outlined
                dense
              />
            </v-col>
          </v-row>

        </v-card-text>

        <v-divider class="mt-1"></v-divider>

        <v-card-actions class="justify-center py-3">
          <v-btn outlined small @click="regresar">
            <v-icon>arrow_back</v-icon> Regresar
          </v-btn>

          <v-btn outlined small color="warning" @click="reset">
            <v-icon>restart_alt</v-icon> Limpiar
          </v-btn>

          <v-btn 
            color="primary" 
            small 
            :loading="loading" 
            :disabled="loading || conteoCertificados > 500 || conteoCertificados === 0" 
            @click="guardar"
          >
            <v-icon>save</v-icon> Guardar
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      conteoCertificados: 0,
      selectedOption: "importacion",
      loading: false,
      formData: {
        importacionSeleccion: null,
        rangoDesde: null,
        rangoHasta: null,
        cursoAnio: null,
        cursoPromocion: null,
        cursoNombre: null,
        cursoTutor: null,
        cursoSeccion: null,
        numeroIdentidad: null,
      },
      importaciones: [],
      años: this.generarAños(),
      promociones: [],
      resultadosNombre: [],
      tutores: [],
      secciones: [],
    };
  },

  watch: {
    'formData.importacionSeleccion'() { this.calcularConteo(); },
    'formData.rangoDesde'() { this.calcularConteo(); },
    'formData.rangoHasta'() { this.calcularConteo(); },
    'formData.cursoAnio'() { this.cargarPromociones(this.formData.cursoAnio); },
    'formData.cursoPromocion'() { this.cargarCursos(this.formData.cursoAnio,this.formData.cursoPromocion); },
    'formData.cursoNombre'() {  this.cargarTutores();},
    'formData.cursoTutor'() { this.cargarSecciones();},
    'formData.cursoSeccion'() { this.calcularConteo(); },
    'formData.numeroIdentidad'() { if(this.formData.numeroIdentidad && this.formData.numeroIdentidad.length == 13) this.calcularConteo(); }
  },

  methods: {
    resetForm() {
      this.conteoCertificados = 0;
      this.formData = {
        importacionSeleccion: null,
        rangoDesde: null,
        rangoHasta: null,
        cursoAnio: null,
        cursoPromocion: null,
        cursoNombre: null,
        cursoTutor: null,
        cursoSeccion: null,
      };
      this.searchNombre = '';
      this.tutores = [];
      this.secciones = [];
    },

    generarAños() {
      const currentYear = new Date().getFullYear();
      const startYear = 2015;
      const years = [];
      for (let year = currentYear; year >= startYear; year--) {
        years.push(year.toString());
      }
      return years;
    },

    cargarPromociones(año) {
      this.promociones = [];
      this.formData.cursoPromocion = null;
      this.resultadosNombre = [];
      this.formData.cursoNombre = null;
      if (!año) return;
      this.loading = true;
      window.axios
        .get("lotes_impresion/listar-promociones", { params: { q: JSON.stringify({ año: parseInt(año) }) } })
        .then(res => { this.promociones = res.data.data.promociones || []; })
        .finally(() => { this.loading = false; });
    },

    cargarCursos(año, promocion) { 
      this.resultadosNombre = [];
      this.formData.cursoNombre = null;
      if (!año || !promocion) return;
      this.loading = true;
      window.axios
        .get("lotes_impresion/listar-cursos", { params: { q: JSON.stringify({ año: parseInt(año), promocion: parseInt(promocion) }) } })
        .then(res => { this.resultadosNombre = res.data.data.cursos || []; })
        .finally(() => { this.loading = false; });
    },

    cargarTutores() {
      this.tutores = [];
      this.formData.cursoTutor = null;
      this.secciones = [];
      this.formData.cursoSeccion = null;

      const { cursoAnio, cursoPromocion, cursoNombre } = this.formData;
      if (!cursoAnio || !cursoPromocion || !cursoNombre) return;

      this.loading = true;
      window.axios
        .get("lotes_impresion/listar-tutores", { 
          params: { q: JSON.stringify({ año: parseInt(cursoAnio), promocion: parseInt(cursoPromocion), nombre: cursoNombre }) } 
        })
        .then(res => { this.tutores = res.data.data.tutores || []; })
        .finally(() => { this.loading = false; });
    },

    cargarSecciones() {
      this.secciones = [];
      this.formData.cursoSeccion = null;

      const { cursoAnio, cursoPromocion, cursoNombre, cursoTutor } = this.formData;
      if (!cursoAnio || !cursoPromocion || !cursoNombre || !cursoTutor) return;

      this.loading = true;
      window.axios
        .get("lotes_impresion/listar-secciones", { 
          params: { q: JSON.stringify({ año: parseInt(cursoAnio), promocion: parseInt(cursoPromocion), nombre: cursoNombre, tutor: cursoTutor }) } 
        })
        .then(res => { this.secciones = res.data.data.secciones || []; })
        .finally(() => { this.loading = false; });
    },

    calcularConteo() {
        // Example logic, replace with actual API or calculation
        if (this.selectedOption === 'importacion') {
          let importacion_id = this.formData.importacionSeleccion;
          if (!importacion_id) return; // avoid querying on empty or too-short input
          let query = {
            "tipo":"importacion",
            "importacion_id": importacion_id
          }
          this.loading = true;          
          window.axios
            .get("lotes_impresion/conteo-certificados", { params: { q: btoa(JSON.stringify(query)) } })
            .then(res => {
              this.conteoCertificados = res.data.data.conteo || 0;
            })
            .finally(() => {
              this.loading = false;
            });
        } else if (this.selectedOption === 'rango') {
          let desde = parseInt(this.formData.rangoDesde);
          let hasta = parseInt(this.formData.rangoHasta);
          if (!desde || !hasta || desde > hasta) {
            this.conteoCertificados = 0;
            return; // avoid querying on empty or invalid input
          }
          
          let query = {
            "tipo":"rango_registros",
            "desde": desde,
            "hasta": hasta
          }
          this.loading = true;          
          window.axios
            .get("lotes_impresion/conteo-certificados", { params: { q: btoa(JSON.stringify(query)) } })
            .then(res => {
              this.conteoCertificados = res.data.data.conteo || 0;
            })
            .finally(() => {
              this.loading = false;
            });

        } else if (this.selectedOption === 'curso') {
          const { cursoAnio, cursoPromocion, cursoNombre, cursoTutor, cursoSeccion } = this.formData;
          if (!cursoAnio || !cursoPromocion || !cursoNombre || !cursoTutor || !cursoSeccion) {
            this.conteoCertificados = 0;
            return;
          }
          const query = {
            tipo: "curso",
            año: parseInt(cursoAnio),
            promocion: parseInt(cursoPromocion),
            nombre: cursoNombre,
            tutor: cursoTutor,
            seccion: cursoSeccion
          };
          this.loading = true;
          window.axios
            .get("lotes_impresion/conteo-certificados", { params: { q: btoa(String.fromCharCode(...new TextEncoder().encode(JSON.stringify(query)))) } })
            .then(res => { this.conteoCertificados = res.data.data.conteo || 0; })
            .finally(() => { this.loading = false; });
        } else if (this.selectedOption === 'estudiante') {
          const numeroIdentidad = this.formData.numeroIdentidad;
          if (!numeroIdentidad) {
            this.conteoCertificados = 0;
            return;
          }
          const query = {
            tipo: "estudiante",
            numero_identidad: numeroIdentidad
          };
          this.loading = true;
          window.axios
            .get("lotes_impresion/conteo-certificados", { params: { q: btoa(String.fromCharCode(...new TextEncoder().encode(JSON.stringify(query)))) } })
            .then(res => { this.conteoCertificados = res.data.data.conteo || 0; })
            .finally(() => { this.loading = false; });
        }

    },

    guardar() {
      let body = null;

      if (this.selectedOption === 'importacion') {
        const importacion_id = this.formData.importacionSeleccion;
        if (!importacion_id) {
          return;
        }
        body = {
          tipo: 'importacion',
          params: { "importacion_id": importacion_id }
        };
      } else if (this.selectedOption === 'rango') {
        const desde = parseInt(this.formData.rangoDesde);
        const hasta = parseInt(this.formData.rangoHasta);

        if (!desde || !hasta || desde > hasta) {
          return;
        }
        body = {
          tipo: 'rango_registros',
          params: { "desde": desde, "hasta": hasta }
        };

      } else if (this.selectedOption === 'curso') {
        const año = parseInt(this.formData.cursoAnio);
        const promocion = parseInt(this.formData.cursoPromocion);
        const nombre = this.formData.cursoNombre;
        const tutor = this.formData.cursoTutor;
        const seccion = this.formData.cursoSeccion;

        if (!año || !promocion || !nombre || !tutor || !seccion) {
          return;
        }
        body = {
          tipo: 'curso',
          params: { año: año, promocion: promocion, nombre: nombre, tutor: tutor, seccion: seccion }
        };
      } else if (this.selectedOption === 'estudiante') {
        const numeroIdentidad = this.formData.numeroIdentidad;
        if (!numeroIdentidad) {
          return;
        }
        body = {
          tipo: 'estudiante',
          params: { numero_identidad: numeroIdentidad }
        };
      }

      if (!body) return;

      this.loading = true;

      // POST request with normal JSON body
      window.axios
        .post('/lotes_impresion/guardar-nuevo', body)
        .then(res => {
          console.log('Lote guardado:', res.data);
        })
        .catch(err => {
          this.$toast.error(err.response.data.message || 'Error al guardar el lote.');
          console.error('Error al guardar:', err);
        })
        .finally(() => {
          this.loading = false;
        });
        //this.$router.push({ name: 'AdministracionImpresion' });
        this.$router.go(-1);
    },

    cargarListas() {
      this.loading = true;
      window.axios
        .get("lotes_impresion/listar-importaciones")
        .then(res => { this.importaciones = res.data.data.importaciones || []; })
        .finally(() => { this.loading = false; });
    },

    regresar() { this.$router.go(-1); },
    reset() { this.resetForm(); this.selectedOption = 'importacion'; },
  },

  created() {
    this.cargarListas();
  },
};
</script>
